var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCustoms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15 18c.829 0 1.579-.336 2.121-.879l1.415 1.415a5 5 0 1 1 0-7.072l-1.415 1.415A3 3 0 1 0 15 18m0-11a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
})));
export default SvgCustoms;